import Favicon from './favicon';
export default Favicon;
